/**
 * Toast Notification Helpers
 *
 * Consistent toast messages for manual entry operations.
 */

import toast from 'react-hot-toast';

export const toastSuccess = {
  submissionCreated: () => toast.success('Submission created!'),
  employeeAdded: (name: string) => toast.success(`${name} added to submission`),
  employeeUpdated: (name: string) => toast.success(`${name} updated`),
  employeeRemoved: () => toast.success('Employee removed'),
  c10Generated: (count: number) =>
    toast.success(`C10 file generated with ${count} records!`),
  profileSaved: (name: string) => toast.success(`${name} saved to profiles`),
  draftSaved: () => toast.success('Draft saved', { duration: 2000 }),
};

export const toastError = {
  generic: (message?: string) =>
    toast.error(message || 'Something went wrong. Please try again.'),
  validation: (message: string) => toast.error(message),
  network: () => toast.error('Network error. Please check your connection.'),
  featureDisabled: () =>
    toast.error('This feature requires the Manual Entry add-on.'),
  duplicateNI: (ni: string) =>
    toast.error(`Employee with NI ${ni} already exists in this submission`),
};

export const toastLoading = {
  generating: () => toast.loading('Generating C10 file...'),
  saving: () => toast.loading('Saving...'),
};
